import { useMemo, useState, useEffect } from 'react';

const useDevice = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isMobile = useMemo(() => width < 768, [width]);
  const isTablet = useMemo(() => width >= 768 && width < 1024, [width]);
  const isDesktop = useMemo(() => width >= 1024, [width]);

  return { isMobile, isTablet, isDesktop };
};

export default useDevice;
